import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import './i18n';
// The layers of the visual system first, then the shared pieces that read
// them, then the frame of the field experience, then the screens that are
// not on the layers yet (D-174).
import './ui/layers.css';
import './ui/ui.css';
import './ui/frame.css';
import './ui/visit.css';
import './styles.css';
import { App } from './app/App';
import { agenda, engine, field, geo, install, photos, session } from './app/runtime';
import { markUpdateReady, watchForUpdates } from './app/update';
import { db } from './db/database';

// The shell is precached; a new build waits for the next start rather than
// swapping the page under a working operator. INC-13 (B-24): or for the
// person, who is told it is there and chooses the moment (app/update.ts).
// D-83: persistent storage is asked for by the field's runtime, for the role
// that works in the field and for no other.
registerSW({
  immediate: true,
  onNeedRefresh() {
    markUpdateReady();
  },
  onRegisteredSW(_url, registration) {
    if (registration !== undefined) watchForUpdates(registration);
  },
});

const container = document.getElementById('root');
if (container === null) throw new Error('root element is missing');
createRoot(container).render(
  <StrictMode>
    <App runtime={{ db, session, engine, geo, photos, install, agenda, field }} />
  </StrictMode>,
);
